<div class="bar1">
    <button class="goBack" mat-button (click)="backSceneList()" style="margin-top: auto; margin-bottom: auto;">
        <mat-icon>arrow_back</mat-icon>
    </button>


    <div class="center-items">

    <button class="icon-button buttonBarButt" mat-button (click)="saveChanges(true);" [disabled]="!saveMode.saveSceneManual">
        @if (savedIcon) {
        <fa-icon size="xl" [icon]="['fas', 'floppy-disk']" matTooltip="{{'general.save' | transloco}} [Alt+S]"></fa-icon>
        } @else {
        <fa-icon size="xl" [icon]="faFloppyDisk" matTooltip="{{'general.save' | transloco}} [Alt+S]"></fa-icon>
        }
    </button>

    <span class="vl"></span>

        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <button class="icon-button buttonBarButt" mat-button (click)="toggleDragScene();">
                @if (dragSceneEnabled) {
                    <fa-icon size="xl" [icon]="faHand" matTooltip="{{'scenes.move' | transloco}}"></fa-icon>
                } @else {
                    <fa-icon size="xl" [icon]="farHand" matTooltip="{{'scenes.move' | transloco}}"></fa-icon>
                }
            </button>
        }


        @if (previousLinkedSceneId) {
            <button matTooltip="{{'general.goBackPreviousScene' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="onPreviousLinkedScene();">
                <mat-icon class="buttonBarIcon">settings_backup_restore</mat-icon>
            </button>
        }

        <button matTooltip="{{'general.undo' | transloco}} [Ctrl+Z]" class="icon-button buttonBarButt" mat-button (click)="onUndoRedo('UNDO');" [disabled]="disableUndo">
            <mat-icon class="buttonBarIcon">undo</mat-icon>
        </button>
        <button matTooltip="{{'general.redo' | transloco}} [Ctrl+Y]" class="icon-button buttonBarButt" mat-button (click)="onUndoRedo('REDO');" [disabled]="disableRedo">
            <mat-icon class="buttonBarIcon">redo</mat-icon>
        </button>

        <span class="vl"></span>
        <button matTooltip="{{'general.copy' | transloco}} [Ctrl+C]" class="icon-button buttonBarButt" mat-button (click)="onClickCopy();" [disabled]="selectedItemIds.length == 0">
            <fa-icon [icon]="faCopy"></fa-icon>
        </button>
        <button matTooltip="{{'general.paste' | transloco}} [Ctrl+V]" class="icon-button buttonBarButt" mat-button (click)="onClickPaste(true);" [disabled]="!isCut && !isCopy">
            <fa-icon [icon]="faPaste"></fa-icon>
        </button>
        <button matTooltip="{{'general.cut' | transloco}} [Ctrl+X]" class="icon-button buttonBarButt" mat-button (click)="onClickCut();" [disabled]="selectedItemIds.length == 0">
            <fa-icon [icon]="faCut"></fa-icon>
        </button>
        <button matTooltip="{{'general.removeItems' | transloco}} [Delete]" class="icon-button buttonBarButt" mat-button (click)="removeSceneItems()" [disabled]="selectedItemIds.length == 0">
            <mat-icon class="buttonBarIcon">delete</mat-icon>
        </button>

            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <span class="vl"></span>
                <button matTooltip="{{'general.lockItem' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="onClickLock();" [disabled]="selectedItemIds.length == 0">
                    <fa-icon [icon]="faLock"></fa-icon>
                </button>
                <button matTooltip="{{'general.unlockallitems' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="onClickUnlockAll();">
                    <fa-icon [icon]="faLockOpen"></fa-icon>
                </button>
                <button matTooltip="{{'general.hideItem' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="onClickHide();" [disabled]="selectedItemIds.length == 0">
                    <fa-icon [icon]="faEyeSlash"></fa-icon>
                </button>
                <button matTooltip="{{'general.showAll' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="onClickShowAll();">
                    <fa-icon [icon]="faEye"></fa-icon>
                </button>

                <span class="vl"></span>
                <button class="icon-button buttonBarButt" mat-button (click)="onClickChangeMagnetic();">
                    @if (showDirections) {
                        <fa-icon [icon]="faMagnet" size="xl" class="buttonBarIcon" matTooltip="{{'general.magneticAlignmentOff' | transloco}}"></fa-icon>
                    }
                    @if (!showDirections) {
                        <fa-icon [icon]="faMagnet" size="xl" style="opacity: 0.5" class="buttonBarIcon" matTooltip="{{'general.magneticAlignmentOn' | transloco}}"></fa-icon>
                    }
                </button>
                <button matTooltip="{{'general.toggleGuide' | transloco}} [Ctrl+L]" class="icon-button buttonBarButt" mat-button (click)="onClickSetGuidelines();">
                    <mat-icon class="buttonBarIcon">vertical_align_center</mat-icon>
                </button>
                <button matTooltip="{{'general.keyboard' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="onKeyboardHelp();">
                    <mat-icon class="buttonBarIcon">keyboard</mat-icon>
                </button>

                <span class="vl"></span>
                <button matTooltip="{{'general.setBackground' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="convertToBackground();" [disabled]="selectedItemIds.length !== 1 || !enableBackground">
                    <mat-icon class="buttonBarIcon">wallpaper</mat-icon>
                </button>
                <button matTooltip="{{'general.importBackground' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="popupBackgroundWnd();">
                    <mat-icon class="buttonBarIcon">add_photo_alternate</mat-icon>
                </button>
                <button matTooltip="{{'general.about' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="onAbout();">
                    <fa-icon [icon]="sceneData?.Player.$.mimeType | PipeIcon"></fa-icon>
                </button>
            }


                <span class="vl"></span>
                <span class="vl"></span>
<!--
                @if (sceneData.Player.$.mimeType=='mainPlayer') {
                    <button matTooltip="{{'general.registerPlayer' | transloco}}" class="icon-button buttonBarButt" mat-button (click)="showAddPlayerModal();">
                        <mat-icon>queue_play_next</mat-icon>
                    </button>
                }
-->

                <button class="txtColorHighlight icon-button buttonBarButt" mat-button (click)="showPreviewPopup();" matTooltip="{{'general.preview' | transloco}}">
                    <mat-icon class="buttonBarIcon">play_circle</mat-icon>
                </button>



                <div class="position d-flex-center">
                    @if (experienceLevel > experienceLevelType.BEGINNER) {
                        <button class="icon-button buttonBarButt" mat-button disabled>
                            @if (lockedScene == 'edit') {
                                <mat-icon class="buttonBarIcon" style="font-size: 18px; color: lightgreen;" matTooltip="active scene">edit</mat-icon>
                            }
                            @if (lockedScene == 'locked') {
                                <mat-icon class="buttonBarIcon" style="font-size: 18px; color: red;" matTooltip="locked scene by other user">edit</mat-icon>
                            }
                            @if (!lockedScene) {
                                <mat-icon class="buttonBarIcon" style="font-size: 18px; color: gray;" matTooltip="active scene">edit</mat-icon>
                            }
                        </button>
                    }

                    <app-video-link  style="display: inline-block;" videoLink="overview"></app-video-link>

                </div>

    </div>

    <button class="goBack" mat-button (click)="backSceneList()" matTooltip="{{'navigation.exitScene' | transloco}}" style="margin-right: 0; margin-top: auto; margin-bottom: auto;">
        <mat-icon>close</mat-icon>
    </button>

</div>

<ng-template let-modal #keyboardHelperModal>
    <div mat-dialog-content>
        <div class="helper-image">
            <img src="./assets/images/keys.png">
        </div>
    </div>
</ng-template>

<ng-template let-modal #guidelineModal>
    <h1 mat-dialog-title class="header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content class="guideline-modal">
        <div class="row">
            <div class="option">
                  <span>
                    {{ 'general.alpha' | transloco }}
                  </span>
                <mat-slider class="opacity-slider" [disabled]="!isShowLines" [max]="1" [min]="0" [step]="0.1" color="accent">
                    <input matSliderThumb (valueChange)="changeGuidelines()" [(ngModel)]="guidelineOpacity"/>
                </mat-slider>
            </div>
            <mat-checkbox class="option" [labelPosition]="'before'" [(ngModel)]="isShowLines"
                          (change)="changeGuidelines()">
                {{ 'general.show' | transloco }}
            </mat-checkbox>
            <button mat-icon-button (click)="onClickRemoveGuidelines()" class="option icon-button buttonBarButt textColorOne">
                <mat-icon class="buttonBarIcon" matTooltip="{{'general.removeGuidelines' | transloco}}">delete</mat-icon>
            </button>

        </div>
        <div class="guideline-images" [ngClass]="{'disable': !isShowLines}">
            <img (click)="onClickLineImage(1);" src="./assets/images/guidelines/g1.png">
            <img (click)="onClickLineImage(2);" src="./assets/images/guidelines/g2.png">
            <img (click)="onClickLineImage(3);" src="./assets/images/guidelines/g3.png">
            <img (click)="onClickLineImage(4);" src="./assets/images/guidelines/g4.png">
            <img (click)="onClickLineImage(5);" src="./assets/images/guidelines/g5.png">
            <img (click)="onClickLineImage(6);" src="./assets/images/guidelines/g6.png">
            <img (click)="onClickLineImage(7);" src="./assets/images/guidelines/g7.png">
            <img (click)="onClickLineImage(8);" src="./assets/images/guidelines/g8.png">
            <img (click)="onClickLineImage(9);" src="./assets/images/guidelines/g9.png">
            <img (click)="onClickLineImage(10);" src="./assets/images/guidelines/g10.png">
            <img (click)="onClickLineImage(11);" src="./assets/images/guidelines/g11.png">
            <img (click)="onClickLineImage(12);" src="./assets/images/guidelines/g12.png">
        </div>
    </div>
</ng-template>

<ng-template let-modal #sharedPreviewModal let-width="width">
    <h1 class="preview-dlg-header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon">play_arrow</mat-icon>
                    {{ 'general.play' | transloco }}
                </ng-template>
                <div class="preview-wrapper">
                    <div class="previewSceneLeft">
                        <div class="d-flex-center">
                            <app-scene-selector
                                    [currentSceneId]="selectedSceneId"
                                    [currentSceneName]="'current scene'"
                                    [selectedSceneId]="previewSceneId"
                                    [showJump]="true"
                                    (changeSelectedScene)="changePreviewScene($event)">
                            </app-scene-selector>
                        </div>
                        <mat-radio-group [(ngModel)]="previewMode">
                            <mat-radio-button value="size">
                                <div [ngClass]="{'not-active': previewMode != 'size'}">
                                    <mat-form-field class="custom-size-field">
                                        <mat-label>{{ 'general.width' | transloco }}</mat-label>
                                        <input inputrestriction="basic1" matInput type="number" max="7680" [(ngModel)]="previewSizeX"
                                               placeholder="" autocomplete="off">
                                    </mat-form-field>
                                    <mat-form-field class="custom-size-field">
                                        <mat-label>{{ 'general.height' | transloco }}</mat-label>
                                        <input inputrestriction="basic1" matInput type="number" max="7680" [(ngModel)]="previewSizeY"
                                               placeholder="" autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </mat-radio-button>
                            <br/>
                            <mat-radio-button value="percent">
                                <div [ngClass]="{'not-active': previewMode != 'percent'}">
                                    <mat-form-field class="custom-size-field">
                                        <mat-label>{{ 'general.percent' | transloco }}</mat-label>
                                        <mat-select [(ngModel)]="previewPercent">
                                            @for (p of percentages; track p) {
                                                <mat-option [value]="p">{{ p }}%</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="previewSceneRight">
                        <div class="embeddedDialog2" fxLayout="column" fxLayoutAlign="start start">
                            <button class="icon-button buttonBarButt" mat-raised-button (click)="showAddPlayerModal()">
                                <mat-icon class="buttonBarIcon">queue_play_next</mat-icon>&nbsp;&nbsp;
                                {{'general.registerPlayer' | transloco}}
                            </button>
                            <br/>
                            <button class="icon-button buttonBarButt" mat-raised-button (click)="openEmbedded()">
                                <mat-icon class="buttonBarIcon">code</mat-icon>&nbsp;&nbsp;
                                {{ 'general.webEmbedded' | transloco }}
                            </button>
                            <br/>
                            <button class="icon-button buttonBarButt" mat-raised-button (click)="copyTextClipboard()">
                                <mat-icon class="buttonBarIcon">content_copy</mat-icon>&nbsp;&nbsp;
                                {{ 'general.copyLink' | transloco }}
                            </button>
                            <br/>
                            <button class="buttonBarButt" mat-raised-button (click)="qrLinkPrint()">
                                <mat-icon class="buttonBarIcon">qr_code_scanner</mat-icon>&nbsp;&nbsp;
                                {{ 'general.qrCode' | transloco }}
                            </button>
                            <br>
                            <mat-checkbox [(ngModel)]="rememberSelection" (change)="changeRemeberSelection()">{{ 'account.rememberMe' | transloco }}</mat-checkbox>
                            <br>
                        </div>
                    </div>
                    <div class="clearFloat">
                    </div>

                    <div style="text-align: center;">
                        <button color="warn" class="previewButton" mat-raised-button (click)="onClickPlayPreview()"
                                [disabled]="(!previewSizeX || !previewSizeY || previewSizeX < 100 || previewSizeY < 100) && previewMode === 'size' ">
                            <mat-icon class="buttonBarIcon">play_circle_outline</mat-icon>&nbsp;&nbsp;
                            {{ 'general.webPreview' | transloco }}
                        </button>
                    </div>

                    @if (!isMainScene) {
                        <div style="text-align: center;">
                            <br/>
                            <span class="color-warning" style="font-weight: bold">{{ 'general.warning' | transloco }} for {{ sceneMimeShort }} Scene</span><br/>
                            <span>
                        {{ 'general.previewSpecial' | transloco }}
                      </span>
                        </div>
                    }
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon">track_changes</mat-icon>
                    {{ 'general.socialMedia' | transloco }}
                </ng-template>
                <div class="social-media-wrapper">
                  <span>
                    post scene [{{ sceneData.Player.$.label }}] to your favorite social network
                  </span>
                    <div class="d-flex inline-flex flex-lt-md-col">
                        <div class="media-group">
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'youtube')">
                                <fa-icon size="xl" [icon]="faYouTube"></fa-icon>
                                <span class="social-name">Youtube</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'twitter')">
                                <fa-icon size="xl" [icon]="faTwitter"></fa-icon>
                                <span class="social-name">X</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'facebook')">
                                <fa-icon size="xl" [icon]="faFacebook"></fa-icon>
                                <span class="social-name">FaceBook</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'gmb')">
                                <fa-icon size="xl" [icon]="faGoogleDrive"></fa-icon>
                                <span class="social-name">Google Business</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'tiktok')">
                                <fa-icon size="xl" [icon]="faTiktok"></fa-icon>
                                <span class="social-name">TikTok</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'reddit')">
                                <fa-icon size="xl" [icon]="faReddit"></fa-icon>
                                <span class="social-name">Reddit</span>
                            </mat-checkbox>
                        </div>
                        <div class="media-group">
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'telegram')">
                                <fa-icon size="xl" [icon]="faTelegram"></fa-icon>
                                <span class="social-name">Telegram</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'linkedin')">
                                <fa-icon size="xl" [icon]="faLinkedin"></fa-icon>
                                <span class="social-name">LinkedIn</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'instagram')">
                                <fa-icon size="xl" [icon]="faInstagram"></fa-icon>
                                <span class="social-name">Instagram</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'fbg')">
                                <fa-icon size="xl" [icon]="faFacebook"></fa-icon>
                                <span class="social-name">FaceBook Groups</span>
                            </mat-checkbox>
                            <mat-checkbox (change)="selectSocialMedia($event.checked, 'pinterest')">
                                <fa-icon size="xl" [icon]="faPinterest"></fa-icon>
                                <span class="social-name">Pinterest</span>
                            </mat-checkbox>
                        </div>
                    </div>
                    <br>
                    <div class="d-flex inline-flex flex-lt-md-col" fxLayoutGap="64px">
                        <div fxFlex fxLayout="column">
                            <mat-form-field>
                                <mat-label>{{ 'general.text' | transloco }}</mat-label>
                                <input (change)="isSocialPostReady()" (keyup)="isSocialPostReady()" [(ngModel)]="socialMediaTitle" inputrestriction="basic2" matInput type="text" placeholder="" autocomplete="off">
                            </mat-form-field>
                            <div class="d-flex-center">
                                <mat-form-field style="margin-right: 10px;">
                                    <mat-label>{{ 'general.resource' | transloco }}</mat-label>
                                    <input readonly matInput type="text" [(ngModel)]="socialMediaResourceName">
                                </mat-form-field>
                                <button mat-icon-button class="mini-button" matTooltip="{{'general.addResource' | transloco}}" (click)="selectResource()">
                                    <mat-icon>add_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div fxFlex fxLayout="column" fxLayoutGap="32px" style="position: relative; left: -40px; top: 10px">
                            <app-scene-social-token #appSceneSocialTokenApp [miniMode]="true" (changed)="onSocialKeyChanged($event)"></app-scene-social-token>
                            @if (socialPosting) {
                                <div>
                                    <app-loading [size]="'20px'"></app-loading>
                                </div>
                            }
                            @if (!socialPosting) {
                                <button color="accent" [disabled]="socialPostDisabled" class="icon-button buttonBarButt" mat-raised-button (click)="postToSocial()">
                                    <mat-icon class="buttonBarIcon">content_copy</mat-icon>&nbsp;&nbsp;
                                    {{ 'general.postToSocial' | transloco }}
                                </button>
                            }
                        </div>
                    </div>
                </div>

            </mat-tab>
        </mat-tab-group>

    </div>
</ng-template>

<ng-template let-modal #aboutScene>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div style="position: relative; top: -10px">
            <fa-icon size="1x" matTooltip="{{'general.about' | transloco}}" style="font-size: 3em"
                     [icon]="sceneData?.Player.$.mimeType | PipeIcon"></fa-icon>
            <label style="font-size: 2em; position: relative; left: 10px; top: -5px; font-weight: lighter">
                [ {{ sceneMimeShort }} ]
            </label>
        </div>
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        <div>
            <ul>
                <li>{{ 'general.assignableTo' | transloco }}: {{ sceneMimeShort }} {{ 'general.scenes' | transloco }}
                </li>
                <li>{{ 'general.name' | transloco }}: {{ sceneData?.Player.$.label }}</li>
                <li>{{ 'general.folder' | transloco }}: {{ sceneData?.Player.$.folder }}</li>
                <li>{{ 'general.uniqueId' | transloco }}: {{ sceneData?.Player.$.id }}</li>
                <li>{{ 'general.dimensions' | transloco }}: {{ editorWidth }} x {{ editorHeight }} px</li>
                <li>{{ 'general.totalBlocks' | transloco }}: {{ sceneItems.length }}</li>
            </ul>
        </div>
    </div>
</ng-template>
